module.exports = __webpack_public_path__ + "static/media/products.5ed05b29.csv";